export default __webpack_public_path__ + "static/media/myhours.c4c84c6a.svg";